export default "/images/vendor/flag-icon-css/flags/1x1/nc.svg?046cebb8a66efa64641c9c90e9f077b2";